import {profGral} from 'constants/url';
import useDelete from '../../../components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteProfGral() {
  const deleteProfGral = useDelete(profGral);
  return (deletingOptions: DeletingOptions) => deleteProfGral(deletingOptions);
}

export default useDeleteProfGral;
